<template>
  <div class="row pt-3">
    <div class="col-12 col-md-4 px-0 pr-md-3">
      <label for="description">Valor Mínimo</label>
      <base-input
        v-model="formData.min_value"
        @input="emitInput"
        :error="validateMinValue(formData.min_value)"
        mask="integer"
        placeholder="Ex: 30"
      />
    </div>
    <div class="col-12 col-md-4 px-0 pr-md-3">
      <label for="description">Valor Máximo</label>
      <base-input
        v-model="formData.max_value"
        @input="emitInput"
        :error="validateMaxValue(formData.max_value)"
        mask="integer"
        placeholder="Ex: 300"
      />
    </div>
     <div class="col-12 col-md-4 px-0">
      <label for="description">Peso</label>
      <base-input
        v-model="formData.weight_value"
        @input="emitInput"
        mask="integer"
        placeholder="Ex: 2"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "NumberAvaliationItemStrategy",
  props: {
    value: {
      type: Object,
      default: () => ({
        min_value: null,
        max_value: null,
        weight_value: null,
      }),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
    validateMinValue(value) {
      if (value < 0) {
        return "O valor mínimo deve ser maior ou igual a 0";
      }
      if (value > this.formData.max_value) {
        return "O valor mínimo deve ser menor ou igual ao valor máximo";
      }
      return;
    },
    validateMaxValue(value) {
      if (value < 0) {
        return "O valor máximo deve ser maior ou igual a 0";
      }
      if (value < this.formData.min_value) {
        return "O valor máximo deve ser maior ou igual ao valor mínimo";
      }
      return;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>
